import React from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, ListGroup, ListGroupItem, Row } from "reactstrap"
import { SwitchInputField, TextField } from "components/RenderInput"
import { change, Field, formValueSelector } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { SaveButton } from "components/Buttons"
import { updateVendorPaymentConfig } from "store/actions"

const PaymentSettingsTab = ({
  vendorId,
  vendorPaymentConfig,
  updateVendorPaymentConfig,
  paymentSettingsValues,
  change,
}) => {
  const handleSave = () => {
    updateVendorPaymentConfig({
      ...vendorPaymentConfig,
      ecommerce_enabled: paymentSettingsValues?.eCommerce ? 1 : 0,
      booking_payments_enabled: paymentSettingsValues?.enableBookingPayments
        ? 1
        : 0,
      bookings_percentage: paymentSettingsValues?.bookingPercentage,
      bookings_fee: paymentSettingsValues?.bookingFee,
      form_builders_percentage: paymentSettingsValues?.formBuilderPercentage,
      form_builders_fee: paymentSettingsValues?.formBuilderFee,
      products_percentage: paymentSettingsValues?.productsPercentage,
      products_fee: paymentSettingsValues?.productsFee,
    })
  }

  return (
    <React.Fragment>
      <Row className="my-3">
        <Col>
          <Card className="px-3">
            <CardBody>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col>
                  <p className="pt-3">Enable eCommerce</p>
                </Col>
                <Col xs="auto">
                  <Field
                    name="eCommerce"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                    onChange={(e, value) => {
                      if (value === false) {
                        change(
                          "paymentSettings_setup.enableBookingPayments",
                          false
                        )
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col>
                  <p className="pt-3">Enable payments for Booking</p>
                </Col>
                <Col xs="auto">
                  <Field
                    name="enableBookingPayments"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  <h5>Booking Payouts:</h5>
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs={6} sm="auto" className="mt-2 my-1">
                  <label>Percentage(%)</label>
                </Col>
                {/* xs={3} sm={2} xl={1} */}
                <Col xs={6} sm="auto">
                  <Field
                    name="bookingPercentage"
                    component={TextField}
                    type="number"
                    min="0"
                    max="100"
                  />
                </Col>
                <Col xs={6} sm="auto" className="mt-2">
                  <label>Fee($)</label>
                </Col>
                <Col xs={6} sm="auto">
                  <Field
                    name="bookingFee"
                    component={TextField}
                    type="number"
                    step="0.1"
                    min="0"
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  <h5>Form Builders Payouts:</h5>
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs={6} sm="auto" className="mt-2 my-1">
                  <label>Percentage(%)</label>
                </Col>
                {/* xs={3} sm={2} xl={1} */}
                <Col xs={6} sm="auto">
                  <Field
                    name="formBuilderPercentage"
                    component={TextField}
                    type="number"
                    min="0"
                    max="100"
                  />
                </Col>
                <Col xs={6} sm="auto" className="mt-2">
                  <label>Fee($)</label>
                </Col>
                <Col xs={6} sm="auto">
                  <Field
                    name="formBuilderFee"
                    component={TextField}
                    type="number"
                    step="0.1"
                    min="0"
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  <h5>Products (Subscriptions) Payouts:</h5>
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs={6} sm="auto" className="mt-2 my-1">
                  <label>Percentage(%)</label>
                </Col>
                {/* xs={3} sm={2} xl={1} */}
                <Col xs={6} sm="auto">
                  <Field
                    name="productsPercentage"
                    component={TextField}
                    type="number"
                    min="0"
                    max="100"
                  />
                </Col>
                <Col xs={6} sm="auto" className="mt-2">
                  <label>Fee($)</label>
                </Col>
                <Col xs={6} sm="auto">
                  <Field
                    name="productsFee"
                    component={TextField}
                    type="number"
                    step="0.1"
                    min="0"
                  />
                </Col>
              </Row>
              <Row className="d-flex justify-content-center">
                <Col xs="auto">
                  <SaveButton
                    type="button"
                    content="Save"
                    onClick={handleSave}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.VENDOR_FEATURES)

const mapStateToProps = state => ({
  vendorPaymentConfig: state.clients.vendorPaymentConfig,
  paymentSettingsValues: selector(state, "paymentSettings_setup"),
})

const mapDispatchToProps = dispatch => ({
  updateVendorPaymentConfig: values =>
    dispatch(updateVendorPaymentConfig(values)),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.VENDOR_FEATURES, `${field}`, value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSettingsTab)
